{
  "hero": {
    "title": "Faites de l'or comme si <em>c'était votre métier.<br/></em>",
    "subtitle": "Intelligence de flipping inter-royaumes pour l'hôtel des ventes Retail. Des données en direct, restituées sous forme d'opportunités concrètes — pas un nouveau graphique à déchiffrer.",
    "ctaPrimary": "Démarrer un essai gratuit",
    "ctaSecondary": "Le voir en action",
    "stats": {
      "regions": "Régions",
      "regionsValue": "EU · US",
      "updated": "Rafraîchissement",
      "updatedValue": "Toutes les heures"
    }
  },
  "toolsSection": {
    "label": "Outils",
    "sectionTitle": "Six instruments. Un seul but : l'or.",
    "watchDemo": "Voir la démo",
    "tags": {
      "flippingTool": "Inter-royaumes",
      "dropshipTool": "Marchés vides",
      "realmStats": "Données",
      "tsmListGenerator": "Export TSM",
      "snipeAlerts": "Temps réel",
      "inventoryAnalysis": "Scan d'inventaire"
    }
  },
  "tools": {
    "flippingTool": {
      "title": "Outil de flipping",
      "description": "Outil de flipping inter-royaumes qui analyse les meilleures opportunités pour un objet.",
      "videoTitle": "Outil de flipping inter-royaumes",
      "features": {
        "0": "Trouvez la meilleure opportunité pour un objet basée sur des données en temps réel.",
        "1": "Sélectionnez les royaumes spécifiques sur lesquels vous souhaitez acheter et vendre.",
        "2": "Affiche le profit en or entre le royaume d'achat et de vente.",
        "3": "Calcule le % de profit pour la moyenne de vente vs achat et vente vs achat.",
        "4": "Indique exactement depuis quel royaume / cluster acheter et sur lequel vendre.",
        "5": "Filtres / tri pour différents types d'objets et statistiques de prix"
      }
    },
    "dropshipTool": {
      "title": "Outil de dropship",
      "description": "Outil de dropship qui vous indique quels objets ne sont pas listés sur un serveur pour que vous puissiez les vendre sans concurrence.",
      "videoTitle": "Outil de dropship",
      "features": {
        "0": "Trouvez le meilleur serveur pour vendre sans concurrence",
        "1": "Sélectionnez les royaumes spécifiques sur lesquels vous souhaitez acheter et vendre.",
        "2": "Affiche le profit en or entre le royaume d'achat et de vente.",
        "3": "Calcule le % de profit pour la moyenne de vente vs achat et vente vs achat.",
        "4": "Indique exactement depuis quel royaume / cluster acheter et sur lequel vendre.",
        "5": "Filtres / tri pour différents types d'objets et statistiques de prix"
      }
    },
    "realmStats": {
      "title": "Statistiques de royaume",
      "description": "Informations statistiques sur chaque royaume, prix et données des ventes aux enchères. Cela peut vous aider à décider où acheter et où vendre.",
      "videoTitle": "Statistiques de royaume",
      "features": {
        "0": "Trouvez des informations de prix sur chaque royaume",
        "1": "Voyez quel serveur vend haut ou bas"
      }
    },
    "tsmListGenerator": {
      "title": "Générateur de liste TSM",
      "description": "Outil avancé de génération de listes TSM pour créer des listes d'objets personnalisées basées sur les données.",
      "videoTitle": "Générateur de liste TSM",
      "features": {
        "0": "Utilisez plusieurs sources de prix pour filtrer les meilleurs objets",
        "1": "Créez la liste TSM parfaite basée sur un large éventail de données.",
        "2": "Exportez votre liste TSM personnalisée en 1 clic."
      }
    },
    "snipeAlerts": {
      "title": "Alertes Snipe",
      "description": "Soyez notifié dès qu'un objet sous-évalué, une mascotte ou un BoE ilvl apparaît à l'hôtel des ventes — avant que quelqu'un d'autre ne le rafle.",
      "videoTitle": "Aperçu Alertes Snipe",
      "features": {
        "0": "Surveillez objets, mascottes de combat et BoE ilvl en dessous de votre prix cible.",
        "1": "Recevez des DM Discord ou des webhooks instantanés lorsqu'un snipe est trouvé.",
        "2": "Configurez des seuils par objet via une interface simple et claire."
      }
    },
    "inventoryAnalysis": {
      "title": "Analyse d'inventaire",
      "description": "Collez le CSV d'inventaire de votre addon FlipQueue pour voir instantanément quels objets valent la peine d'être flippés en cross-realm. Utilisez le résultat dans l'addon pour lister sur les meilleurs serveurs.",
      "videoTitle": "Analyse d'inventaire",
      "features": {
        "0": "Analysez votre inventaire actuel face aux prix inter-royaumes en direct.",
        "1": "Repérez instantanément les objets de vos sacs qui sont rentables à flipper."
      }
    }
  },
  "edge": {
    "label": "L'avantage",
    "sectionTitle": "Pourquoi les membres gardent leur abonnement.",
    "items": {
      "0": {
        "title": "Plus d'or.",
        "body": "Nous mettons en avant les flips à plus forte marge par minute d'effort. Votre or-par-heure est le chiffre que nous optimisons."
      },
      "1": {
        "title": "Récupérez vos soirées.",
        "body": "Des heures de scans TSM se condensent en une interface interrogeable. Filtrez, triez, exportez une liste TSM, terminé."
      },
      "2": {
        "title": "Commencez ce soir.",
        "body": "Pas de tableurs, pas d'addons compliqués. La plupart des membres réalisent leur premier flip rentable dès le premier jour."
      }
    }
  },
  "reviews": {
    "label": "Avis",
    "sectionTitle": "Ce que disent nos membres.",
    "videoTitle": "Avis des membres FlippingPal"
  },
  "pricing": {
    "label": "Abonnement",
    "sectionTitle": "Un abonnement. Tous les outils.",
    "subtitle": "L'abonnement donne accès à tous les outils Flipping Pal"
  },
  "faq": {
    "label": "Questions",
    "sectionTitle": "Questions fréquemment posées.",
    "items": {
      "0": {
        "question": "Ai-je accès à tous les outils avec l'abonnement mensuel ?",
        "answer": "Oui, vous aurez un accès complet à tous les outils Flipping Pal."
      },
      "1": {
        "question": "Sur quelle région WoW cela fonctionne-t-il ?",
        "answer": "Les deux : US (NA) et EU (Europe)."
      },
      "2": {
        "question": "Puis-je annuler mon abonnement à tout moment ?",
        "answer": "Oui, vous pouvez annuler votre abonnement à tout moment. Une fois annulé, vous perdrez l'accès aux outils."
      },
      "3": {
        "question": "Quels moyens de paiement sont acceptés ?",
        "answer": "Toute carte de débit/crédit."
      },
      "4": {
        "question": "Si j'ai des questions, serai-je aidé ?",
        "answer": "Oui, si vous avez des questions, posez-les à l'équipe sur le Discord."
      }
    }
  },
  "modal": {
    "close": "Fermer"
  },
  "backToTop": "Retour en haut",
  "footerCta": {
    "joinAsAffiliate": "Devenir affilié",
    "contactUs": "Nous contacter",
    "discord": "Discord",
    "refundPolicy": "Politique de remboursement",
    "privacyPolicy": "Politique de confidentialité",
    "termsAndConditions": "Conditions générales d'utilisation",
    "copyright": "© 2026 Flipping Pal - Tous droits réservés. Par",
    "creatorLabel": "Boophie (Créateur de contenu)"
  }
}
